import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '../../../GlobalUI';
import ProdigyInput from '../../../GlobalUI/ProdigyInput';

function GoogleAnalyticsV4Form({
  setGaMeasurementIds,
  gaMeasurementIds,
  errors,
}) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (gaMeasurementIds.some((id) => id !== '')) {
      setEnabled(true);
    }
  }, [gaMeasurementIds]);
  const onToggleChange = () => {
    if (enabled) {
      setGaMeasurementIds(['', '', '']);
    }
    setEnabled(!enabled);
  };

  const handleOnChange = (index, value) => {
    const temp = [...gaMeasurementIds];
    temp[index] = value.trim().toUpperCase();
    setGaMeasurementIds(temp);
  };

  return (
    <div className="setup-config-section">
      <div className="setup-config-header">Google Analytics V4</div>
      <div className="setup-config-content">
        <b>Enable Google Analytics</b>
        <Toggle value={enabled} onToggle={onToggleChange} />

        {enabled &&
          gaMeasurementIds.map((_, index) => (
            <div>
              <ProdigyInput
                value={gaMeasurementIds[index]}
                label={`Measurement ID`}
                onChangeHandler={(value) => handleOnChange(index, value)}
                error={errors?.[index] ? { msg: errors?.[index] } : null}
              />
            </div>
          ))}
      </div>
    </div>
  );
}

GoogleAnalyticsV4Form.propTypes = {
  gaMeasurementIds: PropTypes.array,
  setGaMeasurementIds: PropTypes.func,
};

export default GoogleAnalyticsV4Form;
